import { checkResponse } from "utils";

const { axios } = window;

// 消息概况
export const getInformOutLines = params => {
  return axios.get(`/inform/informOutLines`, { params }).then(checkResponse);
};

// 查询通知
export const searchNotice = info => {
  return axios
    .get(`/inform/searchInforms`, { params: info })
    .then(checkResponse);
};

// 删除所有消息
export const delAllNotice = () => {
  return axios
    .delete(`/inform/markInformAlreadyDeletedForAll`)
    .then(checkResponse);
};

// 删除消息
export const delNotice = informIds => {
  return axios
    .delete(`/inform/markInformAlreadyDeleted?informIds=${informIds}`)
    .then(checkResponse);
};

// 将所有消息标记为已读
export const readedAllNotice = () => {
  return axios.post(`/inform/markInformAlreadyReadForAll`).then(checkResponse);
};

// 标记消息已读
export const readedNotice = informIds => {
  return axios
    .post(`/inform/markInformAlreadyRead?informIds=${informIds}`)
    .then(checkResponse);
};

// 获取消息详情
export const getNoticeDetails = info => {
  return axios
    .get(`/inform/informDetail`, { params: info })
    .then(checkResponse);
};

// 查询上一条或者下一条
export const getNext = info => {
  return axios
    .get(`/inform/searchInformPreviousOrNext`, { params: info })
    .then(checkResponse);
};

// 根据查询删除消息
export const searchDelInfo = info => {
  return axios
    .delete(`/inform/searchInformsAndMarkDeleted`, { params: info })
    .then(checkResponse);
};

// 根据查询标记为已读
export const searchMarkInfo = info => {
  return axios
    .post(`/inform/searchInformsAndMarkAlreadyRead`, { params: info })
    .then(checkResponse);
};
